import { COMPANY_URL } from "../../constants/apiUrls";
import { apiSlice } from "../apiSlice";

export const searchApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchCompany: builder.query({
      query: ({ searchQuery, worldBoxToken, code }) => ({
        url: `api/company/worldbox-search/?q=${searchQuery}&countrycode=${code}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    searchTrevexCompany: builder.query({
      query: ({ token, searchTerm, code }) => ({
        url: `api/company/details/?search=${searchTerm}&country_code=${code}`,
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    getCompanyNew: builder.query({
      query: ({ id: win, worldBoxToken }) => ({
        url: `api/company/worldbox-search/${win}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      }),
      /* The other half of the company profile's read: a record the user
         reached by WorldBox id rather than a TREVEX one. Claiming it is
         exactly how it stops being unclaimed, so it needs the same tag —
         otherwise /search/<WIN> keeps serving the pre-claim copy. */
      providesTags: (result, error, { id }) => [{ type: "Company", id }],
    }),
  }),
});

export const {
  useSearchCompanyQuery,
  useSearchTrevexCompanyQuery,
  useGetCompanyNewQuery,
} = searchApiSlice;
